export default {
  resetGlobalContext(state) {
    state.Roles = [];
    state.Nations = [];
    state.Partners = [];
    state.PartnerEmployees = [];
    state.Packages = [];
    state.AddOnFeatures = [];
  },

  updateNationsGL(state, payload) {
    state.Nations = payload;
  },

  updateRoles(state, payload) {
    state.Roles = payload;
  },

  updatePartners(state, payload) {
    state.Partners = payload;
  },

  updatePartnerEmployees(state, payload) {
    state.PartnerEmployees = payload;
  },

  updatePackages(state, payload) {
    state.Packages = payload;
  },

  updateAddOnFeatures(state, payload) {
    state.AddOnFeatures = payload;
  },
};
